import Lottie from "react-lottie-player";
import sadAnim from './sad-anim.json'
import { Button, Input, Spinner } from "reactstrap";
import './dialogContent.css'
import { useState } from "react";

export default function DialogContent({onSubmit, onClose, loading}) {
    const [value, setValue] = useState(null)
    return <div className="drawer-main">
        <h6>Cancel Subscription</h6>
        <p className="para-top">we are sorry to see you go!</p>
        <Lottie loop={true}
            animationData={sadAnim}
            play
            style={{ height: 100 }}
            
            />
        <p className="para-bottom">Are you sure you wish to cancel your subscription</p>
        <Input type="text" className="draw-input" placeholder="Share you feedback" readOnly={loading}  value={value} onChange={(e) => setValue(e.target.value)} />
        <div className="d-flex justify-content-between">
            <Button className="button" color="primary"  onClick={() => !loading && onSubmit(value)} >
                {!loading ? 'Continue' : <Spinner size="sm">Loading...</Spinner>}
            </Button>
            <Button className="button" outline={true} onClick={onClose}>Cancel</Button>
        </div>
    </div>
}